import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import { gridBreakpoints } from 'core-components/sitebuilder/models/flexGrid/IGridBreakPoints'

export const getSizeByWidth = (width: number): FlexDirectionBreak => {
  if (width >= gridBreakpoints.breakpoint.xl) {
    return FlexDirectionBreak.p1212
  }
  if (width >= gridBreakpoints.breakpoint.lg) {
    return FlexDirectionBreak.p1012
  }
  if (width >= gridBreakpoints.breakpoint.md) {
    return FlexDirectionBreak.p812
  }
  if (width >= gridBreakpoints.breakpoint.sm) {
    return FlexDirectionBreak.p612
  }
  if (width >= gridBreakpoints.breakpoint.xs) {
    return FlexDirectionBreak.p412
  }
  return FlexDirectionBreak.p212
}
